<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'TreasureTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                return {
                    ...item,
                    geolocation: `${item.latitude}, ${item.longitude}`
                }
            }
        })
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('treasure.table.order'),
                    value: 'id',
                    width: '60px',
                    sortable: false
                },
                {
                    text: this.$t('treasure.table.name'),
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('treasure.table.geolocation'),
                    value: 'geolocation',
                    sortable: false

                },
                {
                    text: '',
                    value: 'action',
                    align: 'right',
                    sortable: false
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
